export const Layout = () => import('@/layout/index.vue')
import { getRouteRoles } from '@/utils/index'

/**
 * 配置管理路由
 */
const routes = {
  path: '/config',
  redirect: 'noRedirect',
  component: Layout,
  meta: {
    icon: 'Setting',
    title: '首页配置',
    roles: [],
    activeMenuTop: '/config',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  },
  children: [
    {
      path: 'carousel',
      name: 'ConfigCarousel',
      redirect: 'noRedirect',
      meta: {
        icon: 'VideoPlay',
        title: '轮播管理',
        roles: ['admin/setting.Carousel/list'],
        activeMenuTop: '/config',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'ConfigCarouselList',
          component: () => import('@/views/setting/carousel/list.vue'),
          meta: {
            title: '轮播管理',
            roles: ['admin/setting.Carousel/list'],
            activeMenuTop: '/config',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'info/:id',
          name: 'ConfigCarouselInfo',
          component: () => import('@/views/setting/carousel/info.vue'),
          meta: {
            title: '轮播信息',
            roles: ['admin/setting.Carousel/list'],
            activeMenu: '/config/carousel/list',
            activeMenuTop: '/config',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'add',
          name: 'ConfigCarouselAdd',
          component: () => import('@/views/setting/carousel/add.vue'),
          meta: {
            title: '轮播添加',
            roles: ['admin/setting.Carousel/list'],
            activeMenu: '/config/carousel/list',
            activeMenuTop: '/config',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'edit/:id',
          name: 'ConfigCarouselEdit',
          component: () => import('@/views/setting/carousel/edit.vue'),
          meta: {
            title: '轮播修改',
            roles: ['admin/setting.Carousel/list'],
            activeMenu: '/config/carousel/list',
            activeMenuTop: '/config',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    },
    {
      path: 'ad',
      name: 'ConfigAd',
      redirect: 'noRedirect',
      meta: {
        icon: 'Picture',
        title: '广告位配置',
        roles: ['admin/config.Ad/list'],
        activeMenuTop: '/config',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'ConfigAdList',
          component: () => import('@/views/config/ad/setting.vue'),
          meta: {
            title: '广告位配置',
            roles: ['admin/config.Ad/list'],
            activeMenuTop: '/config',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'info/:id',
          name: 'ConfigAdInfo',
          component: () => import('@/views/config/ad/info.vue'),
          meta: {
            title: '广告位信息',
            roles: ['admin/config.Ad/list'],
            activeMenu: '/config/ad/list',
            activeMenuTop: '/config',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'add',
          name: 'ConfigAdAdd',
          component: () => import('@/views/config/ad/add.vue'),
          meta: {
            title: '广告位添加',
            roles: ['admin/config.Ad/list'],
            activeMenu: '/config/ad/list',
            activeMenuTop: '/config',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'edit/:id',
          name: 'ConfigAdEdit',
          component: () => import('@/views/config/ad/edit.vue'),
          meta: {
            title: '广告位修改',
            roles: ['admin/config.Ad/list'],
            activeMenu: '/config/ad/list',
            activeMenuTop: '/config',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    },
    {
      path: 'package-config',
      name: 'ConfigPackageConfig',
      redirect: 'noRedirect',
      meta: {
        icon: 'ShoppingBag',
        title: '套餐显示配置',
        roles: ['admin/config.PackageConfig/list'],
        activeMenuTop: '/config',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'ConfigPackageConfigList',
          component: () => import('@/views/config/package-config/list.vue'),
          meta: {
            title: '套餐显示配置',
            roles: ['admin/config.PackageConfig/list'],
            activeMenuTop: '/config',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'info/:id',
          name: 'ConfigPackageConfigInfo',
          component: () => import('@/views/config/package-config/info.vue'),
          meta: {
            title: '套餐显示配置信息',
            roles: ['admin/config.PackageConfig/list'],
            activeMenu: '/config/package-config/list',
            activeMenuTop: '/config',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'add',
          name: 'ConfigPackageConfigAdd',
          component: () => import('@/views/config/package-config/add.vue'),
          meta: {
            title: '套餐显示配置添加',
            roles: ['admin/config.PackageConfig/list'],
            activeMenu: '/config/package-config/list',
            activeMenuTop: '/config',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'edit/:id',
          name: 'ConfigPackageConfigEdit',
          component: () => import('@/views/config/package-config/edit.vue'),
          meta: {
            title: '套餐显示配置修改',
            roles: ['admin/config.PackageConfig/list'],
            activeMenu: '/config/package-config/list',
            activeMenuTop: '/config',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    }
  ]
}

routes.meta.roles = getRouteRoles(routes)

export default routes
